import { useCallback } from 'react'

import useSWR from 'swr'

import { MeetingsAPI } from 'api/index'
import { MeetingTypeDict, MeetingTypeWithId } from 'types/MeetingType'

import useOrgId from './useOrgId'

const fetcher = (url: string) => MeetingsAPI.get(url).then((res) => res.data)

export default function useOrgMeetingTypes() {
  const orgId = useOrgId()
  const { data, error, isLoading, mutate } = useSWR<MeetingTypeDict>(
    orgId ? `/scheduling/settings/organizations/${orgId}` : null,
    fetcher
  )

  const onDelete = useCallback(
    async (meeting: MeetingTypeWithId) => {
      const mutatedData = structuredClone(data) as typeof data
      mutatedData && delete mutatedData[meeting.id]

      mutate(mutatedData, false)
      await MeetingsAPI.delete(
        `/scheduling/settings/organizations/${orgId}/${meeting.id}`
      )
      mutate()
    },
    [mutate, data, orgId]
  )

  return {
    meetingTypes: data,
    isLoading: isLoading || error,
    isError: error,
    onDelete,
  }
}
